import {createContext, useMemo, useState} from 'react';

export const DragContext = createContext<any>({});

interface IProps {}

const Context: React.FC<IProps> = ({children}) => {
    const [dragMode, setDragMode] = useState(false);
    const value = useMemo(() => {
        return {
            dragMode,
            setDragMode,
        };
    }, [dragMode]);

    return <DragContext.Provider value={value}>{children}</DragContext.Provider>;
};

export default Context;
